import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { QuotaService } from '../../services/api/quota.service';
import { QuotaDataService } from '../../services/data/quota-data.service';
import { Quota } from '../../model/Quota';
import {
  PlanMessageType,
  PlanMessagingService,
} from '../../services/signaling/messaging/plan-messaging.service';

@Component({
  selector: 'app-quota-display',
  templateUrl: './quota-display.component.html',
  styleUrls: ['./quota-display.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class QuotaDisplayComponent implements OnInit {
  protected readonly quota = toSignal(this.quotaDataService.employeeQuota$);

  constructor(
    private readonly quotaService: QuotaService,
    protected readonly quotaDataService: QuotaDataService,
    private readonly planSignalingService: PlanMessagingService,
  ) {
    this.planSignalingService
      .onMessage(PlanMessageType.availableQuotaChanged)
      .subscribe((quota: Quota) => {
        this.quotaDataService.updateQuota(quota);
      });
  }

  ngOnInit(): void {
    this.updateQuota();
  }

  protected hasCount(value: number | null | undefined): value is number {
    return value !== null && value !== undefined;
  }

  private updateQuota(): void {
    this.quotaService.getQuota().subscribe({
      next: (quota) => {
        this.quotaDataService.updateQuota(quota);
      },
    });
  }
}
